import React from 'react';

interface CrunchbaseIconProps {
  height?: number;
  className?: string;
}

export const CrunchbaseLogo: React.FC<CrunchbaseIconProps> = ({
  height = 26,
  className,
}) => {
  return (
    <svg
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill="#146aff"
        d="M8.437 15.979a3.195 3.195 0 11.039-2.632h2.463a5.549 5.549 0 10-.021 2.632zM18.454 9.075c-.137 0-.273.008-.408.018a5.5 5.5 0 00-2.726.962V3.831h-2.26v15.956h2.275V19.2a5.545 5.545 0 103.117-10.13zm3.166 5.972c0 .033-.01.067-.015.1a3.359 3.359 0 01-.088.391v.012a3.305 3.305 0 01-.155.4l-.026.05a3.212 3.212 0 01-1.553 1.526 3.15 3.15 0 01-.631.215h-.009c-.1.022-.2.038-.3.051-.014 0-.028 0-.043.006a3.017 3.017 0 01-.345.019 3.226 3.226 0 01-.431-.032l-.1-.015a3.214 3.214 0 01-.811-.251l-.06-.029a3.2 3.2 0 01-.716-.481l-.025-.022a3.222 3.222 0 01-.566-.676l-.013-.022a3.278 3.278 0 01-.207-.394 3.177 3.177 0 01.039-2.631 3.2 3.2 0 012.561-1.817 3.264 3.264 0 01.33-.024 3.2 3.2 0 013.2 3.2 3.152 3.152 0 01-.036.424z"
      />
    </svg>
  );
};
